import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asp-request-success-popup',
  templateUrl: './asp-request-success-popup.component.html',
  styleUrls: ['./asp-request-success-popup.component.scss']
})
export class AspRequestSuccessPopupComponent {

  // Controls visibility from the parent
  @Input() isOpen: boolean = false;

  // true => "Request Updated!", false/undefined => "Request Created!"
  @Input() isUpdate: boolean = false;

  // The request id to display
  @Input() requestId: any = null;

  // Raw created-at timestamp from the API (string), formatted in the template
  @Input() requestCreatedAt: any = null;

  // Success icon shown at the top — defaults to the same gif used across the app
  @Input() successIcon: string = '../../../../assets/icons/icons8-ok.gif';

  // Emitted when the close (X) icon is clicked
  @Output() closePopup = new EventEmitter<void>();

  // Emitted when "Track My Request" is clicked — parent decides where to navigate
  @Output() trackRequest = new EventEmitter<void>();

   constructor(
    private router: Router
  ) {}

  onClose(): void {
    this.closePopup.emit();
    this.router.navigate(['home']);
  }

  onTrackRequest(): void {
    this.trackRequest.emit();
  }
  
}